import {Bm} from '../../../../graphql/generated/types';

/**
 * 복합BM 에 해당하는지 확인
 */
export function isMixedBm(bm: Bm) {
  return [Bm.MixedPay, Bm.MixedWaitfree].includes(bm);
}
